/* ============================================================
   ATLAS — UI OVERLAYS
   ------------------------------------------------------------
   RESPONSABILITÀ:
   - Gestione overlay visuali (loading / offline)
   - SOLO manipolazione DOM
   - NESSUNA logica applicativa
   - NESSUNO stato persistente

   NOTE DI DESIGN:
   - Overlay auto-contenuti (inline style)
   - Nessuna dipendenza da CSS esterni
   - Idempotenti: chiamabili più volte senza effetti collaterali
============================================================ */
(function () {
  'use strict';

  /* ============================
     NAMESPACE INIT
  ============================ */

  if (!window.ATLAS) window.ATLAS = {};
  if (!window.ATLAS.ui) window.ATLAS.ui = {};
  if (!window.ATLAS.ui.overlays) window.ATLAS.ui.overlays = {};

  const overlays = window.ATLAS.ui.overlays;

  /* ============================
     LOADING OVERLAY
  ============================ */

  overlays.showLoading = function () {
    if (!document.body) return;

    let el = document.getElementById('vf-loading-overlay');

    if (!el) {
      el = document.createElement('div');
      el.id = 'vf-loading-overlay';
      el.className = 'atlas-overlay atlas-overlay-loading';
      el.setAttribute('aria-live', 'polite');

      el.style.cssText = `
        position:fixed;
        inset:0;
        background:rgba(0,0,0,.45);
        display:flex;
        align-items:center;
        justify-content:center;
        z-index:120000;
      `;

      el.innerHTML = `
        <div style="
          background:#111;
          color:#fff;
          padding:18px 22px;
          border-radius:12px;
          font-size:15px;
        ">
          Cargando…
        </div>
      `;

      document.body.appendChild(el);
    }

    el.style.display = 'flex';
  };

  overlays.hideLoading = function () {
    const el = document.getElementById('vf-loading-overlay');
    if (el) el.style.display = 'none';
  };

  /* ============================
     OFFLINE OVERLAY
  ============================ */

  overlays.showOffline = function () {
    if (!document.body) return;
    if (document.getElementById('vf-offline-overlay')) return;

    const el = document.createElement('div');
    el.id = 'vf-offline-overlay';
    el.className = 'atlas-overlay atlas-overlay-offline';
    el.setAttribute('aria-live', 'assertive');

    el.style.cssText = `
      position:fixed;
      inset:0;
      background:rgba(0,0,0,.65);
      color:#fff;
      display:flex;
      align-items:center;
      justify-content:center;
      font-size:18px;
      z-index:130000;
      text-align:center;
    `;

    el.innerHTML = `
      <div>
        Connessione persa.<br/>
        Provando riconnessione…
      </div>
    `;

    document.body.appendChild(el);
  };

  overlays.hideOffline = function () {
    const el = document.getElementById('vf-offline-overlay');
    if (el) el.remove();
  };

// ======================================================
// 🔥 MENU CAROUSEL OVERLAY (ATLAS - CLEAN VERSION)
// ======================================================
window.ATLAS = window.ATLAS || {};
window.ATLAS.ui = window.ATLAS.ui || {};

window.ATLAS.ui.showMenuCarousel = function (onClose) {

  if (document.getElementById("atlas-menu-carousel")) return;

  const menu = window.ATLAS?.data?.menu || [];

  const items = menu.filter(i =>
    String(i.featured).toLowerCase() === "true"
  );

  if (!items.length) {
    onClose && onClose();
    return;
  }

  const MODE = "stories"; // oppure "classic"
  if (MODE === "stories") {
    return showStoriesMode(items, onClose);
  }

  const overlay = document.createElement("div");
  overlay.id = "atlas-menu-carousel";

  overlay.style.position = "fixed";
  overlay.style.inset = "0";
  overlay.style.background = "#fff";
  overlay.style.zIndex = "9999999";
  overlay.style.display = "flex";
  overlay.style.flexDirection = "column";
  overlay.style.justifyContent = "flex-end";

  // ❌ CLOSE BUTTON
  const close = document.createElement("div");
  close.innerHTML = "✕";
  close.style.position = "absolute";
  close.style.right = "12px";
  close.style.top = "12px";
  close.style.fontSize = "22px";
  close.style.cursor = "pointer";

  close.style.setProperty("color", "#000", "important");
  close.style.setProperty("background", "rgba(0,0,0,0.05)", "important");

  close.style.borderRadius = "50%";
  close.style.width = "32px";
  close.style.height = "32px";
  close.style.display = "flex";
  close.style.alignItems = "center";
  close.style.justifyContent = "center";
  close.style.zIndex = "1000000";
  close.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";

  close.onclick = () => {
    overlay.remove();
    onClose && onClose();
  };

  overlay.appendChild(close);

  // 🔽 SCROLLER (PRIMA!)
  const scroller = document.createElement("div");
  scroller.style.display = "flex";
  scroller.style.gap = "12px";
  scroller.style.overflowX = "auto";
  scroller.style.padding = "10px 12px";
  scroller.style.scrollBehavior = "auto"; // gestiamo noi

  // ============================
  // 🔥 SWIPE SMOOTH + INERZIA
  // ============================
  let isDown = false;
  let startX;
  let scrollLeft;
  let velocity = 0;
  let lastX;
  let lastTime;

  scroller.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX;
    scrollLeft = scroller.scrollLeft;
    lastX = e.pageX;
    lastTime = Date.now();
  });

  scroller.addEventListener("mouseleave", () => isDown = false);
  scroller.addEventListener("mouseup", () => {
    isDown = false;

    // 🔥 INERZIA
    let momentum = velocity * 20;

    function animate() {
      if (Math.abs(momentum) < 0.5) return;
      scroller.scrollLeft += momentum;
      momentum *= 0.95;
      requestAnimationFrame(animate);
    }
    animate();
  });

  scroller.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    const x = e.pageX;
    const walk = (x - startX) * 1.5;
    scroller.scrollLeft = scrollLeft - walk;

    // velocità per inerzia
    const now = Date.now();
    velocity = (x - lastX) / (now - lastTime);

    lastX = x;
    lastTime = now;
  });

  // ============================
  // 🔥 TOUCH SUPPORT (mobile)
  // ============================
  scroller.addEventListener("touchstart", (e) => {
    startX = e.touches[0].pageX;
    scrollLeft = scroller.scrollLeft;
  });

  scroller.addEventListener("touchmove", (e) => {
    const x = e.touches[0].pageX;
    const walk = (x - startX) * 1.5;
    scroller.scrollLeft = scrollLeft - walk;
  });

  // 🔽 HEADER
  const header = document.createElement("div");
  header.style.color = "#fff";
  header.style.fontSize = "14px";
  header.style.padding = "0 12px 6px";
  header.style.fontWeight = "500";
  header.innerText = "LE NOSTRE MIGLIORI PROPOSTE --- OUR TOP PICKS";

  // 🔽 BOTTOM BLACK AREA
  const bottom = document.createElement("div");
  bottom.style.background = "#000";
  bottom.style.borderTopLeftRadius = "16px";
  bottom.style.borderTopRightRadius = "16px";
  bottom.style.paddingBottom = "10px";

  // ============================
  // 🔥 CARDS
  // ============================
  items.forEach(item => {
    const card = document.createElement("div");
    card.style.minWidth = "160px";
    card.style.background = "#111";
    card.style.color = "#fff";
    card.style.position = "relative";
    card.style.borderRadius = "10px";
    card.style.overflow = "hidden";
    card.style.cursor = "pointer";

    const img = document.createElement("img");
    img.src = item.media_url;
    img.style.width = "100%";
    img.style.height = "120px";
    img.style.objectFit = "cover";

    const title = document.createElement("div");
    title.innerText = item.piatto_it;
    title.style.padding = "8px";
    title.style.fontSize = "14px";

    // ============================
    // 🔥 MINI OVERLAY DETTAGLIO
    // ============================
    const detail = document.createElement("div");
    detail.style.position = "absolute";
    detail.style.inset = "0";
    detail.style.background = "rgba(0,0,0,0.85)";
    detail.style.color = "#fff";
    detail.style.display = "none";
    detail.style.flexDirection = "column";
    detail.style.justifyContent = "center";
    detail.style.padding = "10px";
    detail.style.fontSize = "13px";

    detail.innerHTML = `
      <div style="font-weight:bold; margin-bottom:6px;">
        ${item.piatto_it}
      </div>
      <div style="opacity:0.8; font-size:12px; margin-bottom:6px;">
        ${item.descrizione_it || "Descrizione non disponibile"}
      </div>
      <div style="font-weight:bold;">
        ${item.prezzo || "--"}
      </div>
  ` ;

    let open = false;

    card.onclick = () => {
      open = !open;
      detail.style.display = open ? "flex" : "none";
    };

    card.appendChild(img);
    card.appendChild(title);
    card.appendChild(detail);

    scroller.appendChild(card);
  });

  bottom.appendChild(header);
  bottom.appendChild(scroller);
  overlay.appendChild(bottom);

  document.body.appendChild(overlay);

  // ============================
  // 🔥 Carosello full screen con autoplay
  // ============================
  function showStoriesMode(items, onClose) {
    let index = 0;
    let timer = null;
    let duration = 8000;

    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.background = "#000";
    overlay.style.zIndex = "9999999";
    overlay.style.display = "flex";
    overlay.style.flexDirection = "column";

    // ❌ CLOSE
    const close = document.createElement("div");
    close.innerHTML = "✕";
    close.style.position = "absolute";
    close.style.top = "12px";
    close.style.right = "12px";
    close.style.color = "#fff";
    close.style.fontSize = "22px";
    close.style.zIndex = "10";
    close.style.cursor = "pointer";

    close.onclick = () => {
      clearInterval(timer);
      overlay.remove();
      onClose && onClose();
    };

    overlay.appendChild(close);

    // 🔝 PROGRESS BAR
    const progressWrap = document.createElement("div");
    progressWrap.style.display = "flex";
    progressWrap.style.gap = "4px";
    progressWrap.style.padding = "10px";

    const bars = items.map(() => {
      const bar = document.createElement("div");
      bar.style.flex = "1";
      bar.style.height = "3px";
      bar.style.background = "rgba(255,255,255,0.3)";
      return bar;
    });

    bars.forEach(b => progressWrap.appendChild(b));
    overlay.appendChild(progressWrap);

    let currentAnimation = null;

    // 🎬 SLIDE
    const slide = document.createElement("div");
    slide.style.flex = "1";
    slide.style.position = "relative";
    slide.style.touchAction = "pan-y";
    overlay.appendChild(slide);

    // ============================
    // 🎬 RENDER
    // ============================
    function render() {
      const item = items[index];

      // reset animazione precedente
      if (currentAnimation) {
        currentAnimation.cancel();
        currentAnimation = null;
      }

      slide.innerHTML = `
        <div style="
          position:absolute;
          inset:0;
          background:#000;
        "></div>

        <div style="
          position:absolute;
          inset:0;
          overflow:hidden;
        ">
        <img id="story-img" src="${item.media_url}" style="
            position:absolute;
            height:100%;
            width:auto;
            left:0;
            top:0;
            pointer-events:none;
            user-select:none;
          " draggable="false"/>
        </div>

        <!-- BACKDROP TESTO -->
        <div style="
          position:absolute;
          bottom:0;
          left:0;
          right:0;
          padding:20px 16px;
          background:linear-gradient(
            transparent,
            rgba(0,0,0,0.85)
          );
        ">
        <div style="font-size:18px; font-weight:bold; color:#fff; text-shadow:0 2px 6px rgba(0,0,0,0.8);">
          ${item.piatto_it}
        </div>
        <div style="font-size:14px; color:#fff; opacity:0.9; text-shadow:0 2px 6px rgba(0,0,0,0.8);">
          ${item.descrizione_it || ""}
        </div>
        <div style="margin-top:6px; font-weight:bold; color:#fff; text-shadow:0 2px 6px rgba(0,0,0,0.8);">
          ${item.prezzo || ""}
        </div>
      </div>
      `;

      const imgEl = slide.querySelector("#story-img");

      imgEl.onload = () => {
        const containerWidth = slide.clientWidth;
        const imgWidth = imgEl.offsetWidth;
        const overflow = imgWidth - containerWidth;

        if (overflow > 0) {
          currentAnimation = imgEl.animate([
            { transform: `translateX(0px)` },
            { transform: `translateX(-${overflow}px)` }
          ], {
            duration: duration,
            easing: "linear",
            fill: "forwards"
          });
        } else {
          imgEl.style.left = "50%";
          imgEl.style.transform = "translateX(-50%)";
        }
      };

      bars.forEach((b, i) => {
        b.style.background = i <= index ? "#fff" : "rgba(255,255,255,0.3)";
      });
    }

    // ============================
    // ⏭ NEXT
    // ============================
    function next() {
      if (index < items.length - 1) {
        index++;
        render();
      } else {
        clearInterval(timer);
      }
    }

    // ============================
    // ⏱ AUTOPLAY
    // ============================
    function startAuto() {
      clearInterval(timer);
      timer = setInterval(next, duration);
    }

    // ============================
    // 👉 TOUCH LOGIC (SEMPLICE E STABILE)
    // ============================
    let startX = 0;
    let isMoved = false;
    let pressTimer = null;
    let isPressing = false;

    slide.addEventListener("touchstart", e => {
      clearInterval(timer);

      if (currentAnimation) currentAnimation.pause();

      startX = e.touches[0].clientX;
      isMoved = false;
      isPressing = false;

      pressTimer = setTimeout(() => {
        isPressing = true;
      }, 250);
    });

    slide.addEventListener("touchmove", e => {
      const moveX = e.touches[0].clientX;

      if (Math.abs(moveX - startX) > 10) {
        isMoved = true;
        clearTimeout(pressTimer);
      }
    });

    slide.addEventListener("touchend", e => {
      clearTimeout(pressTimer);

      const diff = e.changedTouches[0].clientX - startX;

      // 👉 SWIPE
      if (isMoved && Math.abs(diff) > 50) {
        if (diff > 0) {
          index = Math.max(0, index - 1);
        } else {
          index = Math.min(items.length - 1, index + 1);
        }

        render();
        startAuto();
        if (currentAnimation) currentAnimation.play();
        return;
      }

      // 👉 TAP
      if (!isPressing && !isMoved) {
        next();
        startAuto();
        if (currentAnimation) currentAnimation.play();
        return;
      }

      // 👉 PRESS → resume
      if (isPressing) {
        startAuto();
        if (currentAnimation) currentAnimation.play();
      }
    });

    slide.addEventListener("touchcancel", () => {
      clearTimeout(pressTimer);
      startAuto();
      if (currentAnimation) currentAnimation.play();
    });

    // ============================
    // INIT
    // ============================
    document.body.appendChild(overlay);
    render();
    startAuto();
  }

};
})();
